import { Box, Paper, Stack, Typography, alpha } from "@mui/material";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import CircularProgress from "@mui/material/CircularProgress";

const DEFAULT_BRAND = {
  main: "#2471A3",
  dark: "#1B4F72",
  light: "#EAF2F8",
  accent: "#F39C12",
  surface: "#F4F7F9",
  border: "#E1E8ED",
};

function NoHayRegistros({ clienteNombre, BRAND = DEFAULT_BRAND, loadingRemitos }) {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
      <Paper
        elevation={0}
        sx={{
          position: "relative",
          overflow: "hidden",
          width: "100%",
          borderRadius: 3,
          p: { xs: 2, sm: 2.5 },
          textAlign: "left",
          border: `1px solid ${BRAND.border}`,
          bgcolor: "#ffffff",
          boxShadow: "0 1px 3px rgba(16,42,67,0.06)",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: 6,
            background: `linear-gradient(90deg, ${BRAND.main} 0%, ${BRAND.dark} 100%)`,
          }}
        />

        {loadingRemitos ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              py: 1.5,
              gap: 2,
            }}
          >
            <CircularProgress sx={{ color: BRAND.main }} size={32} />
            <Typography variant="body2" sx={{ color: BRAND.dark, fontWeight: 500 }}>
              Buscando remitos/pedidos sin facturar...
            </Typography>
          </Box>
        ) : (
          <Stack direction="row" spacing={2.5} alignItems="center">
            {/* Icono a la izquierda */}
            <Box
              sx={{
                width: 64,
                height: 64,
                flexShrink: 0,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: BRAND.light,
                border: `1px solid ${alpha(BRAND.main, 0.25)}`,
              }}
            >
              <Inventory2OutlinedIcon sx={{ fontSize: 36, color: BRAND.main }} />
            </Box>

            {/* Contenido a la derecha */}
            <Box sx={{ flexGrow: 1 }}>
              <Typography
                variant="h6"
                component="h2"
                sx={{ fontWeight: 700, mb: 0.5, color: BRAND.dark }}
              >
                No hay registros
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  lineHeight: 1.4,
                  color: "#5B6B7A",
                  mb: 1,
                }}
              >
                {clienteNombre ? (
                  <>
                    El cliente{" "}
                    <Box
                      component="span"
                      sx={{ fontWeight: 700, color: BRAND.main }}
                    >
                      {clienteNombre.trim()}
                    </Box>{" "}
                    no tiene pedidos / remitos pendientes de facturación.
                  </>
                ) : (
                  "Este cliente no tiene pedidos / remitos pendientes de facturación."
                )}
              </Typography>

              <Box
                sx={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 1,
                  px: 1.5,
                  py: 0.5,
                  borderRadius: 2,
                  bgcolor: alpha(BRAND.accent, 0.12),
                }}
              >
                <PersonSearchIcon sx={{ fontSize: 16, color: "#B9770E" }} />
                <Typography
                  variant="caption"
                  sx={{ color: "#B9770E", fontWeight: 600 }}
                >
                  Seleccioná otro cliente para continuar..
                </Typography>
              </Box>
            </Box>
          </Stack>
        )}
      </Paper>
    </Box>
  );
}

export default NoHayRegistros;
